export function OutlineTreeDiagramIcon({
  width = 24,
  height = 24,
  fill = 'none',
  stroke = 'currentColor',
  strokeWidth = 2,
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.9825 7.00318C13.088 7.00318 13.9841 6.10704 13.9841 5.00159C13.9841 3.89614 13.088 3 11.9825 3C10.8771 3 9.98096 3.89614 9.98096 5.00159C9.98096 6.10704 10.8771 7.00318 11.9825 7.00318Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.9825 20.9993C13.088 20.9993 13.9841 20.1031 13.9841 18.9977C13.9841 17.8922 13.088 16.9961 11.9825 16.9961C10.8771 16.9961 9.98096 17.8922 9.98096 18.9977C9.98096 20.1031 10.8771 20.9993 11.9825 20.9993Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.98426 20.9993C6.08971 20.9993 6.98585 20.1031 6.98585 18.9977C6.98585 17.8922 6.08971 16.9961 4.98426 16.9961C3.87881 16.9961 2.98267 17.8922 2.98267 18.9977C2.98267 20.1031 3.87881 20.9993 4.98426 20.9993Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.9811 20.9993C20.0865 20.9993 20.9827 20.1031 20.9827 18.9977C20.9827 17.8922 20.0865 16.9961 18.9811 16.9961C17.8756 16.9961 16.9795 17.8922 16.9795 18.9977C16.9795 20.1031 17.8756 20.9993 18.9811 20.9993Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.9827 6.99805V17.0012"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.9809 17.0016V13.92C18.9809 12.8592 18.1217 12 17.0609 12H6.90412C5.84333 12 4.98413 12.8592 4.98413 13.92V17.0016"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
